import request from '@/utils/request'

export function notifyCheck () {
  return request({
    url: '/front/notify/check/',
    method: 'get'
  })
}

export function notifyNew (query) {
  return request({
    url: '/front/notify/new/',
    method: 'get',
    params: query
  })
}

export function notifyList (query) {
  return request({
    url: '/front/notify/list/',
    method: 'get',
    params: query
  })
}
